import { m } from "@recobra/i18n/messages";
import type { ChecklistRequirement, Task } from "@recobra/schemas/task";

import { type ContextLinkTarget, contextLinkParams, findContextLinkTarget } from "../task-links";

/** Where a row sends the assignee: a configured item's page, or a case's documents for a requested one. */
export type ChecklistRowDestination = {
  to: string;
  params: Record<string, string>;
  search?: Record<string, string>;
  label: string;
};

const CASE_DOCUMENTS = { to: "/cases/$caseNumber", search: { tab: "documents" } };

/** The row's destination; null without one, or when its configured page no longer exists. */
export const checklistRowLink = (
  requirement: ChecklistRequirement,
  task: Pick<Task, "contextType" | "contextId" | "contextCaseNumber">,
  targets: readonly ContextLinkTarget[],
): ChecklistRowDestination | null => {
  const params = contextLinkParams(task);
  if (!params) return null;
  if (requirement.kind === "requested_document")
    return task.contextType === "case"
      ? { ...CASE_DOCUMENTS, params, label: m.task_requirement_go_to_documents() }
      : null;
  const target = requirement.link && findContextLinkTarget(targets, requirement.link);
  return target
    ? {
        to: target.to,
        params,
        search: target.search,
        label: m.task_requirement_go_to({ page: target.label }),
      }
    : null;
};
